module.exports = __webpack_public_path__ + "resources/img/ico_delete.4dfb100eb5c415445ae5406d93a096b5.gif";